import { useRef } from 'react';

// UN NODO CHE CAMBIA GENITORE SENZA RINASCERE.
//
// Alcune sezioni cambiano casa quando cambia l'attracco: la libreria passa dall'Outliner alla
// striscia, World ed Effects dal rail di sinistra al rail dell'Inspector. Lo step 6 chiede che
// siano **gli stessi nodi, non copie** — due copie sono due stati da tenere d'accordo — e che
// **si spostino solo se il genitore è cambiato davvero**, perché rimuovere e rimettere un nodo
// a ogni giro gli fa perdere il fuoco e azzera lo scorrimento.
//
// In React spostare un componente da un genitore all'altro lo smonta e lo rimonta: lo stato se
// ne va. La sola via è tenerlo fermo nell'albero di React — dentro un portale — e spostare il
// **nodo DOM** che lo ospita. Questo hook è quel nodo.

export const useMovableHost = () => {
    const hostRef = useRef<HTMLDivElement | null>(null);

    if (!hostRef.current && typeof document !== 'undefined') {
        hostRef.current = document.createElement('div');
        // Il nodo è un mezzo di trasporto, non un aspetto: riempie il genitore che lo ospita,
        // qualunque dei due sia, e non aggiunge niente di suo.
        hostRef.current.style.cssText = 'display:flex;flex-direction:column;min-height:0;height:100%;';
    }

    /** `null` lo toglie di scena: la sezione resta viva, semplicemente non si vede. */
    const moveTo = (parent: HTMLElement | null) => {
        const host = hostRef.current;
        if (!host) return;

        if (!parent) {
            host.remove();
            return;
        }

        if (host.parentElement !== parent) parent.appendChild(host);
    };

    return { hostRef, moveTo };
};
